import { Component } from "react";
import { AlertTriangle } from "lucide-react";

// Rede de segurança contra tela em branco (30/09/2026, ver lib/api.js pro bug específico
// que motivou isso — e-mail inválido no cadastro de cliente derrubando a árvore inteira do
// React). Esse componente é a segunda camada: cobre qualquer outro erro de render não
// tratado que venha a aparecer no futuro, em qualquer tela do app, mostrando uma mensagem
// amigável com botão de recarregar em vez de deixar a tela completamente em branco sem
// nenhuma pista do que aconteceu.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Erro não tratado, capturado pelo ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-stone-50 px-6">
          <div className="text-center max-w-sm">
            <AlertTriangle className="w-10 h-10 mx-auto text-gold-600 mb-4" strokeWidth={1.5} />
            <h1 className="font-display text-xl font-bold text-stone-900 mb-2">
              Algo deu errado
            </h1>
            <p className="text-sm text-stone-500 mb-6">
              A página encontrou um erro inesperado. Recarregue pra continuar — nenhum dado
              seu foi perdido.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-md bg-stone-900 text-white text-sm font-medium hover:bg-stone-800"
            >
              Recarregar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
